import { useEffect, useRef } from 'react'
import { useAppDispatch } from 'store'
import { updateCurrentPerpSymbol } from 'store/perp/actions'
import { useCurrentPerpSymbol, usePerpSymbols } from 'store/perp/hooks'
import { updateCurrentSpotSymbol } from 'store/spot/actions'
import { useCurrentSpotSymbol, useSpotSymbols } from 'store/spot/hooks'
import { useEffectOnce, useInterval } from 'usehooks-ts'
import { useCurrentSymbol, useMarketTradeType } from './hooks'
import { TradeType } from './types'
import { getMarketBarAction } from './actions/getMarketBarActions'
import { getMarketIndexesAction } from './actions/getMarketIndexesActions'
import { getMarketTradesAction } from './actions/getMarketTradesActions'
import { ACCOUNT_INFO_POLLING_INTERVAL } from 'config'
import { getExternalPricesAction } from './actions/getExternalPrices'
import { useIsLogin } from 'store/account/hooks'

function useWatchTradeType() {
  const dispatch = useAppDispatch()
  const tradeType = useMarketTradeType()
  const currentSpotSymbol = useCurrentSpotSymbol()
  const currentPerpSymbol = useCurrentPerpSymbol()
  const spotSymbols = useSpotSymbols()
  const perpSymbols = usePerpSymbols()

  useEffect(() => {
    if (tradeType !== TradeType.Spot) {
      dispatch(updateCurrentSpotSymbol(0))
    }
    if (tradeType !== TradeType.Perp) {
      dispatch(updateCurrentPerpSymbol(0))
    }
  }, [
    tradeType,
    currentSpotSymbol,
    currentPerpSymbol,
    spotSymbols,
    perpSymbols,
  ])
}

function useFetchBar() {
  const dispatch = useAppDispatch()
  const { name = '' } = useCurrentSymbol()

  useEffect(() => {
    if (!name) return
    dispatch(getMarketBarAction({ symbol: name, type: 'DAY' }))
  }, [name])
}

// function useAllTicker() {
//   const dispatch = useAppDispatch()
//   useEffectOnce(() => {
//     dispatch(getAllTickerAction())
//   })
//   useInterval(() => {
//     dispatch(getAllTickerAction())
//   }, ACCOUNT_INFO_POLLING_INTERVAL)
// }
function usePollingExternalPrices() {
  const dispatch = useAppDispatch()
  const isLogin = useIsLogin()
  useEffect(() => {
    if (!isLogin) return
    dispatch(getExternalPricesAction())
  }, [isLogin])
  useInterval(
    () => {
      dispatch(getExternalPricesAction())
    },
    isLogin ? ACCOUNT_INFO_POLLING_INTERVAL : null,
  )
}

function usePollingIndexes() {
  const dispatch = useAppDispatch()
  const lastTrigger = useRef(Date.now())

  useEffectOnce(() => {
    dispatch(getMarketIndexesAction())
  })

  useEffect(() => {
    let timeout: any
    const interval = setInterval(() => {
      const now = Date.now()
      if (Math.floor(now / 5000) !== Math.floor(lastTrigger.current / 5000)) {
        lastTrigger.current = now
        // The server needs time to update the Redis cache, so the request is delayed by 2 seconds.
        timeout = setTimeout(() => {
          dispatch(getMarketIndexesAction())
        }, 2000)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])
}

export default function Updater() {
  const dispatch = useAppDispatch()

  useWatchTradeType()
  useFetchBar()

  useEffectOnce(() => {
    dispatch(getMarketTradesAction())
  })

  usePollingIndexes()
  usePollingExternalPrices()

  return null
}
